<template>
  <div id="top" class="w-full">
    <div class="w-full bg-gray-200 p-1 border-b mb-2">
      <div class="grid grid-cols-1 sm:grid-cols-5 gap-1">
        <YInput label="Advertiser" v-model="filters.advertiserName.value" />
        <Superselect
          title="Last Run Status"
          v-model="filters.lastRunStatus.value"
          placeholder="Last Run Status"
          :multiple="false"
          :options="filterOptions.lastRunStatus"
        />
        <Superselect
          title="Helpers"
          v-model="filters.helpers.value"
          placeholder="Helpers"
          :multiple="false"
          :options="filterOptions.helpers"
        />
      </div>
    </div>

    <YTable
      v-if="advertiserRevshare?.data"
      :data="advertiserRevshare?.data"
      :loading="$apollo.queries.advertiserRevshare.loading"
    >
      <template slot="header-row">
        <th>Advertiser</th>
        <th>Account ID</th>
        <th>Helper Class</th>
        <th>Status</th>
        <th>Last Run Status</th>
        <th>Last Run Message</th>
        <th>Last Pulled</th>
        <th>URL</th>
      </template>
      <template slot="row" slot-scope="props">
        <td>
          <router-link
            :to="{
              name: 'Advertiser',
              params: { id: props.rowData.advertiserAccount.advertiser.id }
            }"
            class="link block"
          >
            {{ props.rowData.advertiserAccount.advertiser.id }} -
            {{ props.rowData.advertiserAccount.advertiser.name }}
          </router-link>
        </td>
        <td>{{ props.rowData.advertiserAccountId }}</td>
        <td>{{ props.rowData.helperClass }}</td>
        <td class="text-center">
          <Tag
            :color="
              props.rowData.status === 'Ok'
                ? 'blue'
                : props.rowData.status === 'active'
                ? 'darkGreen'
                : props.rowData.status === 'dead'
                ? 'darkRed'
                : 'gray'
            "
          >
            {{ props.rowData.status }}
          </Tag>
        </td>
        <td class="text-center">
          <Tag
            v-if="props.rowData.lastStatus"
            :color="
              lastStatusColors[
                props.rowData.lastStatus
                  ? props.rowData.lastStatus.toLowerCase()
                  : ''
              ] || 'gray'
            "
          >
            {{ props.rowData.lastStatus }}
          </Tag>
        </td>

        <td>
          {{
            props.rowData.lastStatus &&
            props.rowData.lastStatus.toLowerCase() !== 'ok'
              ? props.rowData.lastMessage
              : ''
          }}
        </td>
        <td>{{ props.rowData.lastPulled }}</td>
        <td>{{ props.rowData.url }}</td>
      </template>
    </YTable>

    <YPagination
      v-if="advertiserRevshare?.paginatorInfo"
      :data="advertiserRevshare?.paginatorInfo"
      @load-page="loadPage"
      @next-page="nextPage"
      @previous-page="previousPage"
      :key="totalPages"
      @per-page="perPageSelection"
    >
    </YPagination>
  </div>
</template>

<script>
import ADVERTISER_ACCOUNT_REVSHARE_HELPER_QUERY from '@/graphql/AdvertiserAccount/AdvertiserAccountRevshareHelpers.gql'
import YPagination from '@/components/ui/YPagination.vue'
import BackToTop from '@/mixins/BackToTopMixin.js'

export default {
  mixins: [BackToTop],
  components: { YPagination },
  apollo: {
    advertiserRevshare: {
      query: ADVERTISER_ACCOUNT_REVSHARE_HELPER_QUERY,
      debounce: 250,
      variables() {
        return {
          orderBy: this.orderBy,
          first: this.perPage,
          page: this.currentPage,
          filters: this.cleanFilters()
        }
      },
      update: data => data.advertiserAccountRevshareHelpers,
      deep: true,
      refetch: false
    }
  },
  data() {
    return {
      advertiserRevshare: null,

      filters: {
        advertiserName: {
          value: undefined,
          modifiers: { matchType: 'contains' }
        },
        lastRunStatus: { value: undefined },
        helpers: { value: undefined }
      },
      filterOptions: {
        lastRunStatus: ['Empty', 'Error', 'Ok', 'Unknown'],
        helpers: [
          'MapHelper',
          'MyAffiliatesHelper',
          'CellxpertHelper',
          'CellxpertApiHelper',
          'OxTrafficHelper',
          'IncomeAccessHelper',
          'SoftSwissHelper',
          'ReferOnHelper',
          'BuffaloPartnersHelper'
        ]
      },
      lastStatusColors: {
        empty: 'gray',
        error: 'red',
        ok: 'green',
        unknown: 'orange'
      },
      currentPage: 1,
      perPage: 20,
      totalPages: 0,
      orderBy: [
        {
          column: 'last_pulled',
          order: 'DESC'
        }
      ]
    }
  },
  methods: {
    cleanFilters() {
      const filters = {}

      Object.entries(this.filters).forEach(([key, filterObj]) => {
        if (
          filterObj.value !== undefined &&
          filterObj.value !== null &&
          filterObj.value !== ''
        ) {
          let val = filterObj.value
          if (key === 'lastRunStatus' && typeof val === 'string') {
            val = val.toLowerCase()
          }

          filters[key] = {
            ...filterObj,
            value: val
          }
        }
      })

      return filters
    },
    loadPage(page) {
      this.currentPage = page
      this.backToTop()
    },
    nextPage() {
      this.currentPage++
      this.backToTop()
    },
    previousPage() {
      this.currentPage--
      this.backToTop()
    },
    perPageSelection(value) {
      this.perPage = value
    }
  },
  watch: {
    filters: {
      immediate: false,
      handler() {
        this.$apollo.queries.advertiserRevshare.refetch()
      }
    }
  }
}
</script>
